<template>
    <div class="mb-3">
        <slot name="before-filter"></slot>

        <b-row no-gutters>
            <b-col md="12" class="my-1 d-flex" v-if="!hideHeader">
                <template v-if="mounted">
                    <slot name="add">
                        <b-button
                            v-if="auth_level >= '100' && formModalId && !hideAdd"
                            variant="none"
                            class="mr-2"
                            @click="add"
                            ref="addButton"
                            >
                            <font-awesome-icon icon="plus" />
                        </b-button>
                    </slot>
                </template>
                <b-form class="flex-grow-1" @submit="search">
                    <b-form-group class="mb-0">
                        <b-input-group>
                            <slot :form="form" :init="detail" name="search-prepend"></slot>
                            <b-form-input
                                v-model="grid.filters.q"
                                :placeholder="filtersQPlaceholder"
                                type="search"
                                ></b-form-input>
                            <b-input-group-append>
                                <b-button type="submit">
                                    <font-awesome-icon icon="search" />
                                </b-button>
                            </b-input-group-append>
                            <b-input-group-append
                                v-if="!hideDownload"
                                >
                                <b-button type="button" @click="download">
                                    <font-awesome-icon icon="download" />
                                </b-button>
                            </b-input-group-append>
                            <slot :form="form" :init="detail" name="search-append"></slot>
                        </b-input-group>
                    </b-form-group>
                </b-form>
                <b-button
                    variant="none"
                    class="ml-2"
                    @click="ui.showGridFilter = !ui.showGridFilter"
                    v-if="filterItems.length > 0"
                    >
                    <font-awesome-icon icon="sliders-h" />
                </b-button>
            </b-col>
            <b-col md="12">
                <b-collapse id="grid-filter" v-model="ui.showGridFilter">
                    <b-row class="mx-0">
                        <b-col class="text-right">
                            <small>
                                <b-link @click="resetFilter">全てクリア</b-link>
                            </small>
                        </b-col>
                    </b-row>
                    <b-row class="mx-0">
                        <filter-item
                            v-for="item in filterItems"
                            :key="item.vModel"
                            v-model="grid.filters[item.vModel]"
                            :title="item.title"
                            :type="item.type"
                            :options="item.options"
                            @update="search"
                            />
                    </b-row>
                </b-collapse>
            </b-col>
        </b-row>

        <slot name="before-table" :response="grid.response"></slot>
    
        <template v-if="grid.response.data && grid.response.data.hits && grid.response.data.hits.length">
            <b-table
                :items="grid.response.data.hits"
                :fields="[{ key: 'column', class: 'text-left' }]"
                hover
                thead-class="font-weight-bold"
                thead-tr-class="d-none"
                @row-clicked="onRowClicked"
                v-if="!hideTable"
                >
                <template slot="thead-top" slot-scope="data">
                    <b-row class="d-none d-md-flex p-2">
                        <slot :item="data.item" name="header"></slot>
                    </b-row>
                </template>
                <template v-slot:cell(column)="data">
                    <b-row :class="'d-flex p-0 ' + rowClass">
                        <slot :item="data.item" name="column"></slot>
                    </b-row>
                </template>
            </b-table>
        </template>

        <slot name="after-table"></slot>
    
        <template v-if="grid.response.data && grid.response.data.hits && grid.response.data.hits.length">
            <Pagenation
                v-model="grid.filters.page"
                :nb-pages="grid.response.data.nbPages"
                :nb-hits="grid.response.data.nbHits"
                @input="pagenation"
                v-if="!hidePagenation"
                />

        </template>
    
        <template v-if="mounted">
            <slot :form="form" :init="detail" name="form"></slot>
        </template>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import FilterItem from '@/components/FilterItem.vue'
import Pagenation from '@/components/Pagenation.vue'

export default {
    components: {
        FilterItem,
        Pagenation,
    },
    props: {
        filtersQPlaceholder: {
            type: String,
            required: true,
            default() {
                return 'キーワード'
            },
        },
        filtersDefault: {
            type: Object,
            required: true,
            default() {
                return {}
            },
        },
        filterItems: {
            type: Array,
            required: true,
            default() {
                return []
            },
        },
        formModalId: {
            type: String,
            required: false,
            default() {
                return ''
            },
        },
        formDefault: {
            type: Object,
            required: true,
            default() {
                return {}
            },
        },
        searchAction: {
            type: String,
            required: true,
            default() {
                return ''
            },
        },
        afterMount: {
            type: Function,
            required: false,
            default() {
                return function () {}
            },
        },
        openDetailForOneHit: {
            type: Boolean,
            required: false,
            default() {
                return false
            },
        },
        openDetailAfterSaving: {
            type: Boolean,
            required: false,
            default() {
                return true
            },
        },
        searchAfterSaving: {
            type: Boolean,
            required: false,
            default: false,
        },
        hideAdd: {
            type: Boolean,
            required: false,
            default() {
                return false
            },
        },
        hideDownload: {
            type: Boolean,
            required: false,
            default() {
                return true
            },
        },
        hideHeader: {
            type: Boolean,
            required: false,
            default() {
                return false
            },
        },
        hideTable: {
            type: Boolean,
            required: false,
            default() {
                return false
            },
        },
        hidePagenation: {
            type: Boolean,
            required: false,
            default() {
                return false
            },
        },
        filterSearchResults: {
            type: [ Function, Boolean, ],
            required: false,
            default: true,
        },
        rowClicked: {
            type: [ Function, Boolean, ],
            required: false,
            default: true,
        },
        rowClass: {
            type: String,
            required: false,
            default: '',
        },
        itemId: {
            type: String,
            required: false,
            default: 'uuid',
        },
    },
    data() {
        return {
            grid: {
                filters: {
                    q: '',
                    page: 1,
                    SILENT: true,
                },
                response: {},
                error: {},
            },
            form: {
                log: [],
            },
            ui: {
                showGridFilter: false,
            },
            mounted: false,
        }
    },
    computed: {
        ...mapGetters([
            'auth_level',
            'auth_name',
            'auth_pages',
            'auth_batches',
        ])
    },
    watch: {
        $route: {
            async handler () {

                this.$bus.$emit('page:route-handler')
            },
            immediate: true
        }
    },
    mounted () {
        this.mounted = true

        this.$bus.$on('modal:saved', (item) => {
            this.pushGrid(item)
            this.$emit('after-save')
        })
        this.$bus.$on('modal:destroyed', (item) => {
            this.deleteGrid(item)
            this.$emit('after-destroy')
        })
//        this.$bus.$on('grid-page:show-detail', (item) => {
////            this.pushGrid(item)
//            this.detail(item)
//                .then((item) => {
//                    this.pushGrid(item)
//                })
//        })

        setTimeout(() => {
            this.grid.filters.SILENT = true
            this.search()
            this.grid.filters.SILENT = false
        }, 1000)

        this.grid.filters = Object.assign(this.grid.filters, this.filtersDefault)

        if (this.$route.params.id) {
            this.grid.filters.q = this.$route.params.id
        } else if (this.$route.params.q) {
            this.grid.filters.q = this.$route.params.q
        }

        this.afterMount(this)
    },
    destroyed () {
    },
    methods: {
        // ...mapActions('member', ['searchMember']),
        search(event, page) {
            if (event instanceof Event) {
                event.preventDefault()
            }
            this.grid.response = {}
            this.grid.error = {}
            this.ui.showGridFilter = false
            this.grid.filters.page = page || 1
            this.$store
                .dispatch(this.searchAction, Object.assign({}, this.filtersDefault, this.grid.filters))
                .then((response) => {
                    if (response.config.params.download) {
                        return
                    }

                    this.grid.response = JSON.parse(JSON.stringify(response.data))
                    if (!this.grid.response.data) {
                        this.$utils.set(this.grid.response, {
                            data: {
                                hits: [],
                            },
                        })
                    }

                    if (typeof this.filterSearchResults === 'function') {
                        this.grid.response = this.filterSearchResults(this.grid.response)
                    }

                    if (this.openDetailForOneHit && this.grid.response.data.nbHits === 1) {
                        this.detail(this.grid.response.data.hits[0])
//                        this.detail(this.grid.response.data.hits[0], 0)
                    }
                })
                .catch((error) => {
                    this.grid.error = error

                    if (typeof this.filterSearchResults === 'function') {
                        this.filterSearchResults(this.grid.error)
                    }
                })
        },
        pagenation(event) {
            if (event instanceof Event) {
                event.preventDefault()
            }
            this.search(event, this.grid.filters.page)
        },
        add(event, afterAdding = null) {
            if (event instanceof Event) {
                event.preventDefault()
            }
            if (!this.formModalId) {
                return
            }
            this.form = JSON.parse(JSON.stringify(this.formDefault))
            this.form.is_edit_mode = true
            this.form.is_new = true
            this.$bvModal.show(this.formModalId)
            if (typeof afterAdding === 'function') {
                this.$nextTick(() => {
                    afterAdding(this.form)
                })
            }
        },
        onRowClicked(item, index, event, show = true) {
            if (this.rowClicked === false) {
                return
            }
            if (typeof this.rowClicked === 'function') {
                return this.rowClicked(event, item, index, show)
            }
            return this.detail(item, index, event, show)
        },
        detail(item, index, event, show = true) {
            return new Promise((resolve, reject) => {
                if (!this.formModalId) {
                    reject(null)
                    return
                }
                let search_params = {}
                search_params[this.itemId] = item[this.itemId]
                this.$store
                    .dispatch(this.searchAction, search_params)
                    .then((response) => {
           //             this.form = JSON.parse(JSON.stringify(response.data.data))
                        this.$utils.set(this.form, response.data.data)
                        this.form.is_new = false
//this.$nextTick(() => {
//})
//                        this.form = response.data.data
//                        this.form.is_edit_mode = false
                        if (show) {
                            this.$bvModal.show(this.formModalId)
                        }
                        let params = {}
                        params['item_' + this.itemId] = item[this.itemId]
                        this.$router.push({ name: this.$router.currentRoute.name, params: params, })
//                        this.$router.push({ name: this.$router.currentRoute.name, params: { item_uuid: item.uuid, }, })
                        resolve(response.data.data)
                    })
                    .catch((error) => {
                        this.grid.error = error
                        reject(error)
                    })
            })
        },
        pushGrid(item) {
            if (!this.grid.response.data
                || !this.grid.response.data.hits
                || !item
            ) {
                return
            }
            for (let i = 0; i < this.grid.response.data.hits.length; i++) {
                if (item[this.itemId] === this.grid.response.data.hits[i][this.itemId]) {
//                if (item.uuid === this.grid.response.data.hits[i].uuid) {
                    this.grid.response.data.hits[i] = Object.assign(
                    this.grid.response.data.hits[i],
                    item
                    )
                    return
                }
            }
            this.grid.response.data.hits.unshift(item)
        },
        deleteGrid(item) {
            for (let i = 0; i < this.grid.response.data.hits.length; i++) {
                if (item[this.itemId] === this.grid.response.data.hits[i][this.itemId]) {
//                if (item.uuid === this.grid.response.data.hits[i].uuid) {
                    this.grid.response.data.hits.splice(i, 1)
                    return
                }
            }
        },
        save(response) {
            if (this.searchAfterSaving) {
                this.resetFilter()
                return
            }
            this.pushGrid(response.data)
            if (this.openDetailAfterSaving) {
                this.detail(response.data)
            }

            this.$emit('after-save')
        },
        destroy(response) {
            this.deleteGrid(response.data)

            this.$emit('after-destroy')
        },
        resetFilter(event) {
            this.grid.filters = Object.assign({}, this.filtersDefault)
            this.search(event)
        },
        download(event) {
            this.$utils.set(this.grid.filters, { download: 1, })
            this.search(event)
            this.$delete(this.grid.filters, 'download')
        },
    },
}
</script>

<style lang="scss" scoped>
.filter-item-option {
    display: block;

    &[active] {
    }

    &:not([active]) {
        opacity: 0.3;
    }

    [type='radio'] {
        display: none;
    }

    .filter-item-option-text {
        cursor: pointer;
    }
}
</style>
